import PropTypes from 'prop-types';
import React from 'react';

import LinkSearchDropdown from 'notebook/mediocre/mentions/LinkSearchDropdown';
import AttachDropdownClass from 'ui-library/attach-dropdown/AttachDropdown';
import {SelectAttachment} from 'ui-library/attach-dropdown/AttachDropdownOptionsMenu';
import {ElementKeyboardEvent} from 'util/Types';

interface PositionedLinkSearchDropdownProps {
  atSignBox: {
    top: number;
    left: number;
    bottom: number;
  };
  close: () => void;
  containerWidth: number;
  containerHeight: number;
  containerIsFullScreen: boolean;
  emptyQueryMessage?: JSX.Element | string;
  fileId: string;
  query: string;
  selectAttachment: SelectAttachment;
  shouldSearchEntities?: boolean;
  shouldSearchStorables?: boolean;
}

class PositionedLinkSearchDropdown extends React.PureComponent<PositionedLinkSearchDropdownProps> {
  static propTypes = {
    atSignBox: PropTypes.shape({
      top: PropTypes.number.isRequired,
      left: PropTypes.number.isRequired,
      bottom: PropTypes.number.isRequired,
    }),
    close: PropTypes.func.isRequired,
    containerWidth: PropTypes.number.isRequired,
    containerHeight: PropTypes.number.isRequired,
    containerIsFullScreen: PropTypes.bool.isRequired,
    emptyQueryMessage: PropTypes.node,
    fileId: PropTypes.string.isRequired,
    query: PropTypes.string.isRequired,
    selectAttachment: PropTypes.func.isRequired,
    shouldSearchEntities: PropTypes.bool,
    shouldSearchStorables: PropTypes.bool,
  };

  static WIDTH = 350;
  static MARGIN = 20;

  attachDropdownRef = React.createRef<LinkSearchDropdown>();

  queryKeydownHandler(e: ElementKeyboardEvent): boolean {
    if (this.attachDropdownRef.current) {
      return this.attachDropdownRef.current.queryKeydownHandler(e);
    }
    return false;
  }

  render(): JSX.Element {
    const maxLeft =
      this.props.containerWidth - PositionedLinkSearchDropdown.WIDTH - PositionedLinkSearchDropdown.MARGIN;

    let dropUp;
    if (this.props.containerIsFullScreen) {
      // Drop down unless doing so would go past the bottom of the editor
      const maxTop =
        this.props.containerHeight - AttachDropdownClass.MAX_HEIGHT - PositionedLinkSearchDropdown.MARGIN;
      dropUp = this.props.atSignBox.bottom > maxTop;
    } else {
      // Drop whichever way there is more space available
      const availableSpaceAbove = this.props.atSignBox.top;
      const availableSpaceBelow = this.props.containerHeight - this.props.atSignBox.bottom;
      dropUp = availableSpaceAbove > availableSpaceBelow;
    }

    return (
      <LinkSearchDropdown
        ref={this.attachDropdownRef}
        close={this.props.close}
        defaultOptionSelected={true}
        dropup={dropUp}
        emptyQueryMessage={this.props.emptyQueryMessage}
        fileId={this.props.fileId}
        query={this.props.query}
        selectAttachment={this.props.selectAttachment}
        shouldSearchEntities={this.props.shouldSearchEntities}
        shouldSearchStorables={this.props.shouldSearchStorables}
        style={{
          left: Math.min(this.props.atSignBox.left, maxLeft),
          top: dropUp ? this.props.atSignBox.top : this.props.atSignBox.bottom,
        }}
        width={PositionedLinkSearchDropdown.WIDTH}
      />
    );
  }
}

export default PositionedLinkSearchDropdown;
